import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  }, []);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      logout();
    }
  }, [logout]);

  useEffect(() => {
    refresh();
    window.addEventListener("gogoats-logout", logout);
    return () => window.removeEventListener("gogoats-logout", logout);
  }, [refresh, logout]);

  const signIn = (token, u) => {
    localStorage.setItem(TOKEN_KEY, token);
    setUser(u);
  };

  return <AuthCtx.Provider value={{ user, setUser, signIn, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
